<section
  class="wishlist-overview-list-section"
  [attr.aria-label]="section().title"
>
  <div class="wishlist-overview-list-section__header">
    <h2>{{ section().title }}</h2>
    @if (hasHiddenRows()) {
      <ui-button size="sm" variant="ghost" (pressed)="handleAllSelected()">
        {{ summaryLabel() }} · Zobacz wszystkie
      </ui-button>
    } @else {
      <span>{{ summaryLabel() }}</span>
    }
  </div>

  <div class="wishlist-overview-list-section__rows">
    @for (row of section().rows; track row.id) {
      <wishlist-row-card [row]="row" (selected)="handleRowSelected($event)" />
    }
  </div>
</section>
